// extracted by mini-css-extract-plugin
export default {"root":"IconSimpleMail_root__rJYpY"};